<script setup lang="ts">
import { computed } from 'vue';
import { amountFormat, AmountFormatConfig } from '@/helpers/amountFormat';
import { useAppStore } from '@/store/app';

const props = defineProps<{
  amount: number;
  config?: AmountFormatConfig;
}>();

const app = useAppStore();

const amountString = computed(() => {
  if (app.hideValues) {
    return '*****';
  }
  return amountFormat(props.amount, props.config);
});
</script>

<template>
  <span class="text-no-wrap">
    {{ amountString }}
  </span>
</template>
